<template>
    <div id="login">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        <template>
                            <div class="text-center" id="logo-login">
                                <img src="img/logo.png" width="200px">
                            </div>

                        </template>
                        <template>
                            <form role="form">
                                <base-input
                                        class="mb-3"
                                        placeholder="Correo electrónico"
                                        v-model="loginData.username"
                                        v-on:keyup.enter="login"
                                        autofocus
                                        addon-left-icon="ni ni-email-83">
                                </base-input>
                                <base-input
                                        type="password"
                                        placeholder="Contraseña"
                                        v-model="loginData.password"
                                        v-on:keyup.enter="login"
                                        addon-left-icon="ni ni-lock-circle-open">
                                </base-input>
                                <base-checkbox v-model="loginData.remember">
                                    <span>Recordar mis datos</span>
                                </base-checkbox>

                                <div class="text-center">
                                    <base-button type="primary" class="my-4" @click.prevent="login"
                                                 :disabled="disabledBotonLogin  == 1 ? true : false">
                                        {{textBotonLogin}}
                                    </base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import swal from 'sweetalert2'

    export default {
        data: function () {
            return {
                errorLogin: false,
                textBotonLogin: "Iniciar sesión",
                disabledBotonLogin: 0,
                loginData: {
                    username: "",
                    password: "",
                    remember: true
                }
            }
        },
        methods: {
            login() {
                this.disabledBotonLogin = 1;
                this.textBotonLogin = "Comprobando...";

                this.checkInputs();
                if (!this.errorLogin) {
                    let vm = this;
                    axios.post(this.$store.getters.apiUrl + 'login', {
                        email: vm.loginData.username,
                        pass: vm.loginData.password,
                    }).then(response => {
                        if (response.data.response) {

                            vm.$store.dispatch("setJWT", response.data.result["jwt"]);
                            vm.$store.dispatch("setUser", response.data.result["user"]);
                            vm.$store.dispatch("setType", response.data.result["type"]);
                            vm.$store.dispatch("setSede", response.data.result["sede"]);
                            vm.$store.dispatch("setSeason", response.data.result["season"]);

                            if (vm.loginData.remember) {
                                var date = new Date;
                                date.setDate(date.getDate() + 21);
                                vm.$cookie.set('jwt', response.data.result["jwt"], {expires: date});
                                vm.$cookie.set('user', response.data.result["user"], {expires: date});
                                vm.$cookie.set('type', response.data.result["type"], {expires: date});
                                vm.$cookie.set('sede', response.data.result["sede"], {expires: date});
                                vm.$cookie.set('season', response.data.result["season"], {expires: date});
                            }

                            // vm.$store.dispatch('fetchBusiness');
                            vm.$router.push("/dashboard");

                        } else {
                            swal({
                                title: 'Atención',
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            this.textBotonLogin = "Iniciar sesión";
                            this.disabledBotonLogin = 0;

                        }
                    }).catch(e => {
                        swal({
                            title: 'Atención',
                            text: e,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        this.textBotonLogin = "Iniciar sesión";
                        this.disabledBotonLogin = 0;

                    });
                } else {
                    this.textBotonLogin = "Iniciar sesión";
                    this.disabledBotonLogin = 0;
                }
            },
            checkInputs() {
                if (this.loginData.username == "") {
                    this.errorLogin = true;
                    swal({
                        title: 'Atención',
                        text: "El email no puede estar en blanco",
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return;
                }

                if (!this.validateEmail(this.loginData.username.trim())) {
                    this.errorLogin = true;
                    swal({
                        title: 'Atención',
                        text: "El email no es válido",
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return;
                }

                if (this.loginData.password == "") {
                    this.errorLogin = true;
                    swal({
                        title: 'Atención',
                        text: "La contraseña no puede estar en blanco",
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return;
                }

                this.errorLogin = false;
            },
            validateEmail: function (email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

        }
    };
</script>
<style scoped>
    #login {
        background: linear-gradient(87deg, #111 0%, #ffcb54 120%) !important;
        min-height: 100vh;
    }

    .container {
        padding-top: 4em;
    }

    #logo-login {
        margin-bottom: 20px;
    }

    @media (max-width: 600px) {
        .container {
            padding-top: 2rem;
        }
    }
</style>
